export const COLUMNS = [
  {
    header: "S.no",
    accessor: "sno",
    footer: "S.no",
  },
  {
    header: "Key",
    accessor: "key",
    footer: "Key",
  },
  {
    header: "Summary",
    accessor: "summary",
    footer: "Summary",
  },
  {
    header: "Reporter",
    accessor: "reporter",
    footer: "Reporter",
  },
  {
    header: "Priority",
    accessor: "priority",
    footer: "Priority",
  },
  {
    header: "Assignee",
    accessor: "assignee",
    footer: "Assignee",
  },
  {
    header: "Created",
    accessor: "created",
    footer: "Created",
  },
  {
    header: "Updated",
    accessor: "updated",
    footer: "Updated",
  },
];
